import Vue from 'vue'
import axios from 'axios'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/jy-act/',
  routes: [
   // 海经贸杯活动
    {
      path: '/hjmb',
      redirect: '/hjmb/index',
    }, {
      path: '/hjmb/index',
      name: 'index',
      component: resolve => require(['@/components/hjmb/index'], resolve),
      meta: {
        title: '“金元经贸联赛杯”投资者教育知识竞赛'
      }
    },
    {
      path: '/hjmb/baoming',
      name: 'hjmbBaoming',
      component: resolve => require(['@/components/hjmb/baoming'], resolve),
      meta: {
        title: '“金元经贸联赛杯”投资者教育知识竞赛'
      }
    },
    {
      path: '/hjmb/tjjddbp',
      name: 'tjjddbp',
      component: resolve => require(['@/components/hjmb/tjjddbp'], resolve),
      meta: {
        title: '“金元经贸联赛杯”投资者教育知识竞赛'
      }
    },
    {
      path: '/hjmb/xxzq',
      name: 'xxzq',
      component: resolve => require(['@/components/hjmb/xxzq'], resolve),
      meta: {
        title: '“金元经贸联赛杯”投资者教育知识竞赛'
      }
    },
    {
      path: '/hjmb/personalInfo',
      name: 'personalInfo',
      component: resolve => require(['@/components/hjmb/personalInfo'], resolve),
      meta: {
        title: '“金元经贸联赛杯”投资者教育知识竞赛'
      }
    },
    {
      path: '/hjmb/question',
      name: 'question',
      component: resolve => require(['@/components/hjmb/question'], resolve),
      meta: {
        title: '“金元经贸联赛杯”投资者教育知识竞赛'
      }
    },
    {
      path: '/hjmb/rank',
      name: 'hjmbRank',
      component: resolve => require(['@/components/hjmb/rank'], resolve),
      meta: {
        title: '排行榜'
      }
    },
    {
      path: '/hjmb/histRank',
      name: 'hjmbHistRank',
      component: resolve => require(['@/components/hjmb/histRank'], resolve),
      meta: {
        title: '历史排行榜'
      }
    },
    {
      path: '/hjmb/myReport',
      name: 'hjmbMyReport',
      component: resolve => require(['@/components/hjmb/myReport'], resolve),
      meta: {
        title: '我的战报'
      }
    },
    {
      path: '/hjmb/myRedPacket',
      name: 'hjmbMyRedPacket',
      component: resolve => require(['@/components/hjmb/myRedPacket'], resolve),
      meta: {
        title: '我的红包'
      }
    },
    // 客服投教活动
    {
      path: '/kfhd',
      redirect: '/kfhd/index',
    },
    {
      path: '/kfhd/index',
      name: 'kfhdindex',
      component: resolve => require(['@/components/kfhd/index'], resolve),
      meta: {
        title: '金元投教知识有奖竞答'
      }
    },
    {
      path: '/kfhd/baoming',
      name: 'kfhdbaoming',
      component: resolve => require(['@/components/kfhd/baoming'], resolve),
      meta: {
        title: '金元投教知识有奖竞答'
      }
    },
    {
      path: '/kfhd/question',
      name: 'kfhdquestion',
      component: resolve => require(['@/components/kfhd/question'], resolve),
      meta: {
        title: '金元投教知识有奖竞答'
      }
    },
    //徒步答题活动
    {
      path: '/tbdt/index',
      name: 'tbdtindex',
      component: resolve => require(['@/components/tbdt/index'], resolve),
      meta: {
        title: '海南证券行业中国特色金融文化知识竞赛'
      }
    },
    {
      path: '/tbdt/baoming',
      name: 'tbdtbaoming',
      component: resolve => require(['@/components/tbdt/baoming'], resolve),
      meta: {
        title: '海南证券行业中国特色金融文化知识竞赛'
      }
    },
    {
      path: '/tbdt/rank',
      name: 'tbdtrank',
      component: resolve => require(['@/components/tbdt/rank'], resolve),
      meta: {
        title: '海南证券行业中国特色金融文化知识竞赛'
      }
    },
    //绑定页面
    {
      path: '/hjmb/bind',
      name: 'bind',
      component: resolve => require(['@/components/bind/bind'], resolve),
      meta: {
        title: '“金元经贸联赛杯”投资者教育知识竞赛'
      }
    },
  ]
})

if (process.env.NODE_ENV == 'development') {} else {
  router.beforeEach((to, from, next) => {
    if(to.path.indexOf("/bind") != -1){
      next()
      return
    }
    /////////////////徒步答题活动start/////////////////////
    if(to.path.indexOf("/tbdt") != -1){
      var ticket = sessionStorage.getItem('ticket');
      var ticketType = sessionStorage.getItem('ticketType');
      var code = getUrlParam('code');
      if(getUrlParam('batch')){
        var batch = getUrlParam('batch');
        sessionStorage.setItem('batch', batch)
      }
      var gotoReg = sessionStorage.getItem('gotoReg');
      if (gotoReg == 'Y') {
        next()
        return;
      }
      if (ticket && ticketType=='tbdt') {
          addAccessLog(to, ticket, next)
          return;
      } else {
        if (!code) {
          getUserCode();
        } else {
          var params= {
            code: code
          }
          axios({
            method: 'get',
            url: "/rs/jy/act/auth/wechatLoginTb",
            params
          }).then(res => {
            if (res.data.errCode == '0') {
              if (to.meta.title) {
                document.title = to.meta.title;
              }
                if (res.data.content) {
                  var data = JSON.parse(res.data.content)
                  sessionStorage.setItem('ticket', data.ticket)
                  sessionStorage.setItem('ticketType','tbdt')
                  console.log('here======='+to.path)
                  if (to.path.indexOf("/baoming") != -1) {
                    window.location.href = '/jy-act/tbdt/index'
                    return;
                  }
                  next()
                } else {
                  window.location.href = '/jy-act/tbdt/baoming'
                  sessionStorage.setItem('gotoReg', 'Y');
                }
            } else {
              alert(res.data.msg)
            }
          })
        }
      }
      return
    }
    /////////////////徒步答题活动end/////////////////////
    var ticket = sessionStorage.getItem('ticket');
    var ticketType = sessionStorage.getItem('ticketType');
    var code = getUrlParam('code');
    var gotoReg = sessionStorage.getItem('gotoReg');
    var activityId = ''
    if (ticket && (ticketType=='hjmb'||ticketType=='kfhd') ) {
      if(to.path.indexOf("/hjmb") != -1){
        activityId = 'hjmb'
      }
      if(to.path.indexOf("/kfhd") != -1){
        activityId = 'kfhd'
      }
      if(sessionStorage.getItem('ticketType') == activityId){
        addAccessLog(to, ticket, next)
        // next()
        return;
      }else{
        sessionStorage.removeItem('ticket')
        sessionStorage.removeItem('ticketType')
        // next()
        window.location.href = '/jy-act/'+activityId+'/baoming'
        return;
      }
    } else {
      if (gotoReg == 'Y') {
        next()
        return;
      } else if (!code) {
        getUserCode();
      } else {
        var params= {
          code: code
        }
        if(to.path.indexOf("/hjmb") != -1){
          params.activityCode = '202609_JYHJMB_REG'
          activityId = 'hjmb'
        }
        if(to.path.indexOf("/kfhd") != -1){
          params.activityCode = '202210_TJZSYJJD_REG'
          activityId = 'kfhd'
        }
        axios({
          method: 'get',
          url: "/rs/jy/act/auth/wechatLogin",
          params
        }).then(res => {
          if (res.data.errCode == '0') {
            if (res.data.content) {
              var data = JSON.parse(res.data.content)

              if (data.ticket) {
                sessionStorage.setItem('ticket', data.ticket)
                sessionStorage.setItem('ticketType', activityId)
                if (to.path.indexOf("/baoming") != -1) {
                  window.location.href = '/jy-act/'+activityId+'/index'
                  return;
                }
                next()
              } else if (data.bindJiNiu && data.bindJiNiu == 'Y') {
                sessionStorage.setItem('gotoReg', 'Y');
                window.location.href = '/jy-act/'+activityId+'/baoming'
              } else if (data.jiNiuToken) {
                if (process.env.NODE_ENV == 'test'){
                  var jiNiuUrl = 'https://www.jiniutech.com/test/activities/userBind/index.html?account=';
                  sessionStorage.setItem('gotoReg', 'Y');
                  window.location.href = jiNiuUrl + data.jiNiuToken + '&merchantId=jyzq&toPath=https://wxtest.jyzq.cn/jy-act/'+activityId+'/baoming'
                }else{
                  var jiNiuUrl = 'https://m.jiniutech.com/hd/userBind/index.html?account=';
                  sessionStorage.setItem('gotoReg', 'Y');
                  window.location.href = jiNiuUrl + data.jiNiuToken + '&merchantId=jyzq&toPath=https://m.jyzq.cn/jy-act/'+activityId+'/baoming'
                }
              }
            } else {
              alert(res.data.msg)
            }
          } else {
            alert(res.data.msg)
          }
        })
      }
    }
  })

}

function addAccessLog(to, ticket, next) {
  let i = location.href.indexOf('#')
  let url = location.href.substring(0, i + 1)
  let params = {
    url: url + to.fullPath,
    ticket,
    source: 'X'
  }
  axios({
    method: 'get',
    url: "/rs/jy/act/addLog",
    params: params,
  }).then(res => {
    /////////////徒步答题活动start//////////////////
    if (to.meta.title) {
      document.title = to.meta.title;
    }
    if(to.path.indexOf("/tbdt") != -1){
      if (to.path.indexOf("/baoming") != -1) {
        window.location.href = '/jy-act/tbdt/index'
        return
      }
    }
   
    /////////////徒步答题活动end//////////////////

    if (res.data.errCode == '0') {
      if (to.meta.title) {
        document.title = to.meta.title;
      }
      if (window._hmt) {
        if (to.path) {
          window._hmt.push(['_trackPageview', '/#' + to.fullPath])
        }
      }
      if (to.path.indexOf("/baoming") != -1) {
        if(to.path.indexOf("/hjmb") != -1){
          window.location.href = '/jy-act/hjmb/index'
        }
        if(to.path.indexOf("/kfhd") != -1){
          window.location.href = '/jy-act/kfhd/index'
        }
        return;
      }
      next();
    } else if (res.data.errCode == '-9999') {
      sessionStorage.removeItem('ticket')
      getUserCode();
    } else {
      if (to.meta.title) {
        document.title = to.meta.title;
      }
      next();
    }
  })
  
  next();
}

function getUserCode() {
  let baseurl = location.href;
  let redirectURL = encodeURIComponent(baseurl); //获取地址
  const base = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=';
  let state;
  let surl;
  let reserveUrl;
  let appid = process.env.appid
  let scope = "snsapi_base";
  window.location.href = base + appid + '&redirect_uri=' + redirectURL + '&response_type=code&scope=' + scope + '#wechat_redirect';
}

function getUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var rrr = decodeURIComponent(window.location.search);
  var r = rrr.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js